import React from "react";
import {PageWrapper} from "../../../../../shared/layout";
import {FilterView, Paginator, Search as SearchBar} from "../../../../../shared/widgets";
import {sortData} from "../../../../../shared/widgets/sortingView/sorting";
import "./report.css";
import {distanceFilterRange, gpsFilterRange} from "./../../utils.js";
import {ListView} from "./../list-view/reportListComponent";
import {reportsType} from "../../utils";
import {GraphViewComponent} from "./../graph-view/graphViewComponent";
import {LineGraphComponent} from "./../graph-view/lineGraphComponent";
import PropTypes from "prop-types";

export class MatrixBodyWrapper extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFilter: distanceFilterRange.ALL,
            placeHolder: 'Search vehicle',
            data: this.props.data,
            filteredData: this.props.data
        };
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.updateSearchedData = this.updateSearchedData.bind(this);
        this.handleDataSorting = this.handleDataSorting.bind(this);
    }

    componentDidMount() {
        this.updateFilterRange(this.props.type);
    }

    updateFilterRange(type) {
        const filterRange = type === reportsType.DISTANCE ? distanceFilterRange : type === reportsType.GPS_QUALITY ? gpsFilterRange : null;
        this.setState({filterRange: filterRange, selectedFilter: distanceFilterRange.ALL});
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            this.setState({
                data: this.props.data,
                filteredData: this.props.data,
            });
        }

        if (prevProps.type !== this.props.type) {
            this.updateFilterRange(this.props.type);
        }
    }


    render() {
        return <div><PageWrapper.Body>
            <div className="graph-wrapper">
                { this.props.type != reportsType.GPS_QUALITY_DETAIL ?
                    <GraphViewComponent type={this.props.type} data={this.props.graphData}/>
                    : <LineGraphComponent type={this.props.detailType} data={this.props.graphData}
                                          threshold={this.props.detailType == reportsType.DISTANCE ? 200 : 2000}/>}
            </div>
        </PageWrapper.Body>
            <div className="report-list">
                <PageWrapper.Body>
                    {!this.props.detailType && <PageWrapper.BodyHeader>
                        <span>Filter   </span>
                        <FilterView
                            selectedValue={this.state.selectedFilter.value}
                            title="Range"
                            menues={this.state.filterRange} onSelect={(value)=> {
                            this.setState({
                                selectedFilter: value,
                                searchString: ''
                            }, ()=> {
                                if (this.props.onFilterChange) {
                                    this.props.onFilterChange(value.slab);
                                }
                            })
                        }}/>

                        {!this.props.detailType && <div className="pull-right search-container">
                            <SearchBar placeHolder={this.state.placeHolder} onSearchChange={this.handleSearchChange}
                                       value={this.state.searchString}
                            />
                        </div>}
                        {this.props.totalItems !== undefined &&
                        <span className="cluster-ip"> Device Count : {this.props.totalItems}</span>}
                    </PageWrapper.BodyHeader>}
                    <div className="list-wrapper">
                        <ListView type={this.props.type} loading={this.props.loading} detailType={this.props.detailType}
                                  content={this.props.data}
                                  navigateTo={this.props.navigateTo}
                        />
                    </div>
                    <Paginator
                        pageNo={this.props.pageNo}
                        totalPages={this.props.totalPages}
                        changePage={(pageNo) => {
                            if (this.props.onPageChange) {
                            this.props.onPageChange(pageNo);
                            }
                        }}
                    />
                </PageWrapper.Body>
            </div>
        </div>
    }

    handleSearchChange(key) {
        this.setState({ searchString: key });

        if (this.props.onSearch) {
            this.props.onSearch(key);
        }
    }


    updateSearchedData(key) {
        this.setState((prevState)=> {
            return {
                filteredData: (key ? (prevState.data.filter((item)=> {
                    return ((item.vehicleNo).toLowerCase().includes(key.toLowerCase()) || (item.deviceId).toLowerCase().includes(key.toLowerCase()));
                })) : prevState.data)
            }
        }, ()=> {
            if (this.state.sortOrder) {
                this.sortFilteredData(this.state.sortOrder, this.state.sortKey);
            }
        })
    }


    /**
     * sort data for the giver key in given order
     * @param order
     * @param key
     */
    handleDataSorting(order, key) {
        this.setState({
            sortOrder: order,
            sortKey: key
        });
        this.sortFilteredData(order, key);
    }

    sortFilteredData(order, key) {
        if (this.state.filteredData) {
            this.setState((previousState)=> {
                return {
                    filteredData: sortData(previousState.filteredData, key, order)
                }
            })

        }
    }
}


MatrixBodyWrapper.propTypes = {
  type: PropTypes.string,
  detailType: PropTypes.string,
  data: PropTypes.array,
  graphData: PropTypes.any,
  loading: PropTypes.bool,
  navigateTo: PropTypes.func,
  onFilterChange: PropTypes.func,
  onSearch: PropTypes.func,
  onPageChange: PropTypes.func,
  pageNo: PropTypes.number,
  totalPages: PropTypes.number,
  totalItems: PropTypes.number,
};